import ScatterChart from "./scatter-chart";
export default ScatterChart;
